var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBasketIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.735 3.794a.604.604 0 00-.47-.258L6.576 3.032a.604.604 0 10-.052 1.208l10.898.47-2.143 6.686H5.744L4.02 2.016a.605.605 0 00-.373-.454L.826.453A.605.605 0 00.384 1.58l2.508.986 1.753 9.545a.605.605 0 00.595.495h.291l-.664 1.844a.503.503 0 00.474.675h.466a1.803 1.803 0 00-.466 1.21c0 1 .814 1.813 1.814 1.813s1.814-.814 1.814-1.814c0-.465-.177-.888-.466-1.21h3.955a1.803 1.803 0 00-.466 1.21c0 1 .813 1.814 1.814 1.814 1 0 1.814-.814 1.814-1.814 0-.465-.178-.888-.466-1.21h.566a.504.504 0 100-1.007H6.058l.544-1.511h9.118c.263 0 .496-.17.576-.42l2.52-7.86a.603.603 0 00-.08-.53zM7.155 17.14a.807.807 0 11.002-1.615.807.807 0 01-.002 1.615zm6.65 0a.807.807 0 11.002-1.615.807.807 0 01-.001 1.615z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketIcon);
export default __webpack_public_path__ + "static/media/basket-icon.4ce1abbc4a0005dae69afc36f81e64fd.svg";
export { ForwardRef as ReactComponent };